export const STORE_HOMEPAGE_SECTION_TYPES = [
  { value: 'hero', labelKey: 'settings.storeSectionHero' },
  { value: 'featured_products', labelKey: 'settings.storeSectionFeatured' },
  { value: 'product_carousel', labelKey: 'settings.storeSectionProductCarousel' },
  { value: 'featured_collections', labelKey: 'settings.storeSectionFeaturedCollections' },
  { value: 'image_text', labelKey: 'settings.storeSectionImageText' },
  { value: 'rich_text', labelKey: 'settings.storeSectionRichText' },
  { value: 'faq_accordion', labelKey: 'settings.storeSectionFaqAccordion' },
  { value: 'image_row', labelKey: 'settings.storeSectionImageRow' },
]

/** Sections merchants may add on product template (excluding locked `product_details`). */
export const STORE_PRODUCT_TEMPLATE_ADD_TYPES = [
  { value: 'hero', labelKey: 'settings.storeSectionHero' },
  { value: 'image_text', labelKey: 'settings.storeSectionImageText' },
  { value: 'rich_text', labelKey: 'settings.storeSectionRichText' },
  { value: 'faq_accordion', labelKey: 'settings.storeSectionFaqAccordion' },
]

export const STORE_LOCKED_SECTION_TYPES = ['product_details']

/** All section types with i18n labels (including product-template-only blocks). */
export const STORE_SECTION_TYPE_LABELS = [
  ...STORE_HOMEPAGE_SECTION_TYPES,
  { value: 'product_details', labelKey: 'settings.storeSectionProductDetails' },
]

export const STORE_THEME_PRESETS = [
  { value: 'classic', labelKey: 'settings.storeThemeClassic' },
  { value: 'bayou', labelKey: 'settings.storeThemeBayou' },
  { value: 'studio', labelKey: 'settings.storeThemeStudio' },
]

export function generateStoreSectionId (type) {
  const slug = String(type || 'section').replace(/_/g, '-')
  const suffix = Math.random().toString(36).slice(2, 8)
  return `section-${slug}-${suffix}`
}

export function createEmptyStoreSection (type) {
  const id = generateStoreSectionId(type)
  const version = 1
  switch (type) {
    case 'hero':
      return {
        id,
        type: 'hero',
        version,
        title: '',
        subtitle: '',
        layout: 'split',
        focal_point: 'center',
        image_url: '',
        imageAssetId: '',
        cta: { label: '', href: '' },
      }
    case 'featured_products':
      return { id, type: 'featured_products', version, title: 'Featured', product_ids: [] }
    case 'product_carousel':
      return { id, type: 'product_carousel', version, title: 'New arrivals', product_ids: [] }
    case 'featured_collections':
      return { id, type: 'featured_collections', version, title: 'Collections', collection_slugs: [] }
    case 'image_text':
      return { id, type: 'image_text', version, title: '', body: '', image_url: '', imageAssetId: '', image_side: 'right' }
    case 'rich_text':
      return { id, type: 'rich_text', version, title: '', html: '' }
    case 'faq_accordion':
      return {
        id,
        type: 'faq_accordion',
        version,
        title: 'FAQ',
        items: [{ question: '', answer: '' }],
      }
    case 'image_row':
      return { id, type: 'image_row', version, title: '', items: [{ image_url: '', imageAssetId: '', alt: '', link: '' }] }
    case 'product_details':
      return { id, type: 'product_details', version, show_title: true }
    default:
      return {
        id,
        type: 'hero',
        version,
        title: '',
        subtitle: '',
        layout: 'split',
        focal_point: 'center',
        image_url: '',
        imageAssetId: '',
        cta: { label: '', href: '' },
      }
  }
}

export function duplicateStoreSection (section) {
  const clone = JSON.parse(JSON.stringify(section))
  clone.id = generateStoreSectionId(clone.type || 'section')
  return clone
}
